import { render, staticRenderFns } from "./Decisions.vue?vue&type=template&id=5b69d58e"
import script from "./Decisions.js?vue&type=script&lang=js&external"
export * from "./Decisions.js?vue&type=script&lang=js&external"
import style0 from "./Decisions.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports